(function() {
	'use strict';

	angular
		.module("pwc.services.wineTable")
		.service("WineTable", wineTable);

	wineTable.$inject = ['lodash', 'Slug', '$filter', '$window', '$log', '$rootScope', '$q', 'UserService', 'WineRepository', 'Utils'];

	function wineTable(lodash, Slug, $filter, $window, $log, $rootScope, $q, UserService, WineRepository, Utils){

		/* jshint validthis: true */
		var self = this;

		self.settings = {
			isLoading: true,
			query: '', // simple query
			column: 0, // active column
			numColumns: 8,
			reverse: false,
			page: 0,
			perPage: 10,
			selectedFilter: null,
			lastIndex: 0
		};

		self.wines = [];

		self.filteredWines = [];

		self.isDirty = false;

		self.toggleSearch = false;

		self.isFiltered = false;

		self.activeHeader = null;

		self.filteredBottleTotal = null;

		self.wineFilters = [
			{ idx: 0, name: 'All', slug: 'all', summary: 'All wine records'},
			{ idx: 1, name: 'Cellar', slug: 'cellar', summary: 'Wines in my cellar'},
			{ idx: 2, name: 'Favorites', slug: 'starred', summary: 'Wines marked as favorite'},
			{ idx: 3, name: 'Wish List', slug: 'wished', summary: 'Wines in my wish list'},
			{ idx: 4, name: 'Tasted Only', slug: 'tasted', summary: "Wines I've only tasted"},
			{ idx: 5, name: 'On Order',  slug: 'ordered', summary: 'Wines on order'},
			{ idx: 6, name: 'Out of Stock',  slug: 'oos', summary: 'Wines currently out of stock'}
		];

		self.sortable = [
			'producer.name',
			'name',
			'vintage',
			'cellar.location',
			'cellar.qty',
			'distinction.name',
			'maturity',
			'recordType'
		];

		self.predicate = null;

		self.activeHeaders = [];

		self.headers = [
			{
				id: 1,
				name: 'Producer',
				field: 'producer.name',
				ngclass: function(record){
					return 'title';
				},
				sort: 'asc'
			},
			{
				id: 2,
				name:'Name',
				field: 'name',
				sort: 'asc'
			},
			{
				id: 3,
				name: 'Vintage',
				field: function(record){
					return record.vintage == 'NV' ? 'NV' : integerSortCallback(record.vintage, true);
				},
				sort: 'asc'
			},
			{
				id: 4,
				name: 'Location',
				field: function(record){
					if (self.settings.selectedFilter.name == 'On Order'){
						return 'On Order';
					}
					return Utils.isNumeric(record.cellar.location) ? parseFloat(record.cellar.location) : record.cellar.location;
				},
				/**
				 * Natural Sort
				 * 
				 * We need to be able to sort all of the following properly
				 * 
				 * Rack 1
				 * Rack 1.1
				 * Rack 2
				 * Rack 2.2
				 * Rack 10
				 * Rack 20
				 * 1
				 * 1.1
				 * 2
				 * 2.1
				 * 3
				 * 3.1
				 * Bin 1
				 * Bin 2
				 * Bin 2.2
				 * Bin 10
				 * 1F
				 * 1.2F
				 * 2F
				 * 10F
				 * 
				 * @param {*} a 
				 * @param {*} b 
				 */
				comparator: function(a, b){
					var aString = a.value ? a.value.toString() : '';
					var bString = b.value ? b.value.toString() : '';
					return aString
						.localeCompare(
							bString, 
							navigator.languages[0] || navigator.language,
							{ numeric: true, ignorePunctuation: true }
						);
				},
				sort: 'asc'
			},
			{
				id: 5,
				name: 'Qty',
				field: function(record){
					if (self.settings.selectedFilter.name == 'On Order'){
						return record.getOnOrderQty();
					}
					return record.cellar.qty;
				},
				sort: 'asc'
			},
			{
				id: 6,
				name: 'Distinction',
				field: 'distinction.name',
				sort: 'asc'
			},
			{
				id: 7,
				name: 'Maturity',
				field: function(record){
					return lodash.get(record, 'cellar.aging.maturity');
				},
				ngclass: function(record){
					return 'maturity-' + lodash.get(record, 'cellar.aging.maturity', 'none').toLowerCase();
				},
				sort: 'asc',
				comparator: function(a, b){
					var maturitiesOrder = [
						'Early',
						'Young',
						'Mature',
						'Old',
						'Late',
						'Uncertain'
					];
					return maturitiesOrder.indexOf(a.value) > maturitiesOrder.indexOf(b.value) ? -1 : 1;
				}
			},
			{
				id: 8,
				name: 'Category',
				field: function(record){
					return getRecordType(record);
				},
				ngclass: function(record){
					return getRecordTypeClass(record);
				},
				sort: 'asc'
			},
			{
				id: 9,
				name: 'Alc. %',
				field: 'abv',
				sort: 'asc'
			},
			{
				id: 10,
				name: 'Body',
				field: 'body',
				sort: 'asc'
			},
			{
				id: 11,
				name: 'Bottle Size',
				field: 'bottleSize.name',
				sort: 'asc'
			},
			{
				id: 12,
				name: 'Region',
				field: function(record){
					var regionName = lodash.get(record, 'region.name');
					return lodash.isNotEmptyOrNull(regionName) ? regionName : lodash.get(record, 'region.country');
				},
				sort: 'asc'
			},
			{
				id: 13,
				name: 'Created',
				field: function(record){
					return lodash.isNotEmptyOrNull(record.created) ? $window.moment(new Date(record.created)).format('YYYY-MM-DD') : null;
				},
				sort: 'asc'
			},
			{
				id: 14,
				name: 'Updated',
				field: function(record){
					return lodash.isNotEmptyOrNull(record.updated) ? $window.moment(new Date(record.updated)).format('YYYY-MM-DD') : null;
				},
				sort: 'asc'
			},
			{
				id: 15,
				name: 'Varietal',
				field: 'varietal.name',
				sort: 'asc'
			},
			{
				id: 16,
				name: 'Vineyard',
				field: 'vineyard.name',
				sort: 'asc'
			},
			{
				id: 17,
				name: 'Type',
				field: 'category.name',
				sort: 'asc'
			},
			{
				id: 18,
				name: 'Rating - 100 pt',
				field: function(record){
					return integerSortCallback(lodash.get(record, 'rating.user.point'));
				},
				sort: 'desc'
			},
			{
				id: 19,
				name: 'Rating',
				field: 'rating.user.general',
				sort: 'asc'
			},
			{
				id: 20,
				name: 'Drink After',
				field: function(record){
					return integerSortCallback(record.cellar.aging.after);
				},
				sort: 'asc'
			},
			{
				id: 21,
				name: 'Drink By',
				field: function(record){
					return integerSortCallback(record.cellar.aging.by);
				},
				sort: 'asc'
			},
			{
				id: 22,
				name: 'Value / Bottle',
				field: function(record){
					return floatSortCallback(record.cellar.value);
				},
				sort: 'asc'
			},
			{
				id: 23,
				name: 'Avg. Purchase Price',
				field: function(record){
					return floatSortCallback(record.avgPurchasePrice());
				},
				sort: 'asc'
			},
			{
				id: 24,
				name: 'ID #',
				field: function(record){
					return integerSortCallback(lodash.get(record, 'cellar.id'));
				},
				sort: 'asc'
			},
			{
				id: 25,
				name: 'Custom/Alt ID #',
				field: 'cellar.ids.custom',
				sort: 'asc'
			},
			{
				id: 26,
				name: 'Rating - Wine Advocate',
				field: function(record){
					return integerSortCallback(lodash.get(record, 'rating.other.advocate'));
				},
				sort: 'asc'
			},
			{
				id: 27,
				name: 'Rating - Wine Enthusiast',
				field: function(record){
					return integerSortCallback(lodash.get(record, 'rating.other.enthusiast'));
				},
				sort: 'asc'
			},
			{
				id: 28,
				name: 'Rating - Wine Spectator',
				field: function(record){
					return integerSortCallback(lodash.get(record, 'rating.other.spectator'));
				},
				sort: 'asc'
			},
			{
				id: 29,
				name: 'Rating - Vinous',
				field: function(record){
					return integerSortCallback(lodash.get(record, 'rating.other.vinous'));
				},
				sort: 'asc'
			},
			{
				id: 30,
				name: 'Rating - James Suckling',
				field: function(record){
					return integerSortCallback(lodash.get(record, 'rating.other.suckling'));
				},
				sort: 'asc'
			},
			{
				id: 31,
				name: 'Country',
				field: 'region.country',
				sort: 'asc'
			},
            {
                id: 32,
                name: 'Grapes',
                field: function(record){
                	var grapes = lodash.get(record, 'grapes', []);
                    return lodash.map(grapes, 'name').join(', ');
                },
                sort: 'desc'
            },
            {
                id: 33,
                name: 'Total Value',
                field: function(record){
                    return floatSortCallback(lodash.get(record, 'cellar.totalValue', 0));
                },
                sort: 'asc'
            }
		];

		/** Available Advanced Query params & filters */
		self.advQuery = {
			"name": {
				name: "Name",
				val: null,
				cb: function (items, val) {
					return $filter('filter')(items, {name: val});
				}
			},
			"producerName": {
				name: "Producer",
				val: null,
				cb: function (items, val) {
					return $filter('filter')(items, {producer: {name: val}});
				}
			},
			"vintage": {
				name: "Vintage",
				val: null,
				cb: function (items, val) {
					return $filter('filter')(items, {vintage: val});
				}
			},
			"varietalName": {
				name: "Varietal",
				val: null,
				cb: function (items, val) {
					return $filter('filter')(items, {varietal: {name: val}});
				}
			},
            "distinctionName": {
                name: "Distinction",
                val: null,
                cb: function (items, val) {
                    return $filter('filter')(items, {distinction: {name: val}});
                }
            },
			"categoryName": {
				name: "Category",
				val: null,
				cb: function (items, val) {
					return $filter('filter')(items, {category: {name: val}});
				}
			},
			"cellarId": {
				name: "ID #",
				val: null,
				cb: function (items, val) {
					return $filter('filter')(items, {cellar: {id: val}});
				}
			},
			"vineyardName": {
				name: "Vineyard",
				val: null,
				cb: function (items, val) {
					return $filter('filter')(items, {vineyard: {name: val}});
				}
			},
			"regionName": {
				name: "Region",
				val: null,
				cb: function (items, val) {
					var region = $filter('filter')(items, {region: {$: val}});
					var parent = $filter('filter')(items, {region: {parent: {name: val}}});
					var filtered = lodash.uniq(lodash.union(region, parent));
					return filtered;
				}
			},
			"countryName": {
				name: "Country",
				val: null,
				cb: function (items, val) {
					return $filter('filter')(items, {region: {country: val}});
				}
			},
			"body": {
				name: "Body",
				val: null,
				cb: function (items, val) {
					return $filter('filter')(items, {body: val});
				}
			},
			"cellarLocation": {
				name: "Location",
				val: null,
				cb: function (items, val) {
					return $filter('filter')(items, {cellar: {location: val}});
				}
			},
			"cellarQty": {
				name: "Min. Qty",
				val: null,
				cb: function (items, val) {
					return lodash.filter(items, function(item){
						return item.cellar.qty >= parseInt(val);
					});
				}
			},
			"bottleSize": {
				name: "Bottle Size",
				val: null,
				cb: function (items, val) {
					return $filter('filter')(items, {"bottleSize": {name: val}});
				}
			},
			"drinkAfter": {
				name: "Drink After",
				val: null,
				cb: function (items, val) {
					return $filter('filter')(items, {"cellar": {"aging": {"after": val}}});
				}
			},
			"drinkBy": {
				name: "Drink By",
				val: null,
				cb: function (items, val) {
					return $filter('filter')(items, {"cellar": {"aging": {"by": val}}});
				}
			},
			"maturity": {
				name: "Maturity",
				val: null,
				cb: function (items, val) {
					return $filter('filter')(items, {"cellar": {"aging": {"maturity": val}}});
				}
			},
			"bottleValue": {
				name: "Bottle Value",
				val: null,
				cb: function (items, val) {
					return minMaxFilter(items, 'cellar.value', val);
				}
			},
			"abv": {
				name: "Alcohol %",
				val: null,
				cb: function (items, val) {
					return minMaxFilter(items, 'abv', val);
				}
			},
			"purchasePrice": {
				name: "Purchase Price",
				val: null,
				cb: function (items, val) {
					var min = val.min;
					var max = val.max;

					$log.debug('Purchase Price Min', min);
					$log.debug('Purchase Price Max', max);

					if (isEmptyOrNull(min) && isEmptyOrNull(max)){
						// nothing to do, return all the items
						return items;
					}

					return lodash.filter(items, function(wine){
						var history = wine.getPurchaseHistory();

						if (history.length === 0){
							return false;
						}

						var matches = false;

						lodash.forEach(history, function(item){
							var price = item.price;
							var result = compare(price, min, max);
							if (result){
								// only update if true, so 1 item in transaction fulfills the filter
								matches = true;
							}
						});

						return matches;
					});
				}
			},
			"pairedFood": {
				name: "Prior Paired Food",
				val: null,
				cb: function (items, val) {
					return $filter('filter')(items, {"cellar": {"history": {"food": val}}});
				}
			},
			"cellarIdsCustom": {
				name: "Custom ID #",
				val: null,
				cb: function (items, val) {
					return $filter('filter')(items, {cellar: {ids: {custom: val}}});
				}
			},
			"cellarIdsBarcode": {
				name: "Barcode #",
				val: null,
				cb: function (items, val) {
					return $filter('filter')(items, {cellar: {ids: {barcode: val}}});
				}
			},
			"dateConsumed": {
				name: "Date Consumed",
				val: {
					min: null,
					max: null
				},
				cb: function (items, val) {
					return $filter('historyFilterFunction')(items, val, 'drink');
				}
			},
			"createdDate": {
				name: "Created Date",
				val: {
					min: null,
					max: null
				},
				cb: function (items, val) {
					return minMaxDateFilter(items, 'created', val);
				}
			},
			"updatedDate": {
				name: "Updated Date",
				val: {
					min: null,
					max: null
				},
				cb: function (items, val) {
					return minMaxDateFilter(items, 'updated', val);
				}
			},
			"purchaseDate": {
				name: "Purchase Date",
				val: {
					min: null,
					max: null
				},
				cb: function (items, val) {
					return $filter('historyFilterFunction')(items, val, 'purchase');
				}
			},
			"saleDate": {
				name: "Sale Date",
				val: {
					min: null,
					max: null
				},
				cb: function (items, val) {
					return $filter('historyFilterFunction')(items, val, 'sale');
				}
			},
            "giftDate": {
                name: "Gift Date",
                val: {
                    min: null,
                    max: null
                },
                cb: function (items, val) {
                    return $filter('historyFilterFunction')(items, val, 'gift');
                }
            },
            "grape": {
                name: "Grape",
                val: null,
                cb: function (items, val) {
                    return $filter('filter')(items, {grapes: {name: val}});
                }
            }
		};

		self.advQueryCollection = [];

		self.removeAdvQuery = removeAdvQuery;
		self.isAdvSearch = isAdvSearch;
		self.resetAdvSearch = resetAdvSearch;
		self.getAdvQuery = getAdvQuery;
		self.setAdvQuery = setAdvQuery;
		self.getActiveHeaderName = getActiveHeaderName;
		self.setActiveHeader = setActiveHeader;
		self.sortHeader = sortHeader;
		self.setFilteredWines = setFilteredWines;
		self.getSelectedFilter = getSelectedFilter;
		self.setFilter = setFilter;
		self.setFilterBySlug = setFilterBySlug;
		self.goToPage = goToPage;
		self.prevPage = prevPage;
		self.nextPage = nextPage;
		self.getFilters = getFilters;
		self.getOffset = getOffset;
		self.getPredicate = getPredicate;
		self.getHeaders = getHeaders;
		self.getWines = getWines;
		self.setWines = setWines;
		self.markLoading = markLoading;
		self.doneLoading = doneLoading;
		self.toggleSearch = toggleSearch;
		self.searchIsActive = searchIsActive;
		self.resetFilters = resetFilters;
		self.wineFilter = wineFilter;
		self.currentPage = currentPage;
		self.getCustomClass = getCustomClass;
		self.getVal = getVal;
		self.resetPagination = resetPagination;
		self.setPerPage = setPerPage;
		self.getFilterSummary = getFilterSummary;
		self.totalPages = totalPages;
		self.sortTableHeader = sortTableHeader;
		self.orderTable = orderTable;
		self.filteredTotal = filteredTotal;
		self.getQuery = getQuery;
		self.setQuery = setQuery;
		self.addWine = addWine;
		self.addWines = addWines;
		self.sortReverse = sortReverse;
		self.isDirty = isDirty;
		self.markDirty = markDirty;
		self.markClean = markClean;
		self.setActiveHeadersByIds = setActiveHeadersByIds;
		self.resetSearch = resetSearch;
		self.chooseAllFilter = chooseAllFilter;
		self.setNumHeaderColumns = setNumHeaderColumns;
		self.removeById = removeById;
		self.appendHeader = appendHeader;

		initialize();

		/**
		 * Initialization
		 */

		function initialize(){
			setFilter(self.wineFilters[1]);

			// populate active headers with user settings or default
			self.activeHeaders = lodash.take(angular.copy(self.headers), lodash.get(UserService.$localStorage, 'columns', self.settings.numColumns));

			self.activeHeader = self.activeHeaders[0];

			registerWatchers();
		}

		/**
		 * Begin Methods
		 */

		function registerWatchers(){

			$rootScope.$watch(function() {
				return self.settings.query;
			}, function watchCallback(newValue, oldValue) {
				applyFiltersAndSearches();
			});

			$rootScope.$watch(function() {
				return self.filteredWines;
			}, function updateBottleTotalCallback(newValue, oldValue) {
				self.filteredBottleTotal = lodash.sum(newValue, function(item) {
					return lodash.get(item, 'cellar.qty', 0);
				});
			});

		}

		function resetSearch(){
			resetAdvSearch();
			self.settings.query = '';
		}

		function minMaxFilter(items, prop, comparator) {

			return lodash.filter(items, function(item){
				var val = lodash.get(item, prop);

				if (comparator.min && comparator.max){
					return lodash.inRange(val, comparator.min, comparator.max);
				}

				if (comparator.min){
					return val >= comparator.min;
				}

				if (comparator.max){
					return val <= comparator.max;
				}
			});
		}

		function minMaxDateFilter(items, prop, comparator) {

			return lodash.filter(items, function(item){
				var val = lodash.get(item, prop, null);

				if (lodash.isNull(val)){
					return false;
				}

				var valDate = $window.moment(new Date(val)).format('YYYY-MM-DD');

				var min = angular.copy(comparator.min);

				var max = angular.copy(comparator.max);

				if (lodash.isNotEmptyOrNull(min)){
					min = $window.moment(min).format('YYYY-MM-DD');
				}

				if (lodash.isNotEmptyOrNull(max)){
					max = $window.moment(max).format('YYYY-MM-DD');
				}

				if (min && max){
					return valDate >= min && valDate <= max;
				}

				if (min){
					return valDate >= min;
				}

				if (max){
					return valDate <= max;
				}

				return false;
			});
		}

		function sortTableHeader(header){
			return lodash.get(header, 'sort', false);
		}

		function stringOrderCallback(predicate){
			return function(record){
				// sorts odd if nulls and undefined are not empty strings
				return lodash.get(record, predicate, '');
			};
		}

		function orderTable(column, bypassToggle){

			// save active column index
			self.settings.column = column;

			if (! lodash.has(self.activeHeaders, column)){
				return false;
			}

			var activeHeader = self.activeHeaders[column];

			var predicate = activeHeader['field'];

			if (lodash.isString(predicate)){
				predicate = stringOrderCallback(predicate);
			}

			if (! bypassToggle){
				self.settings.reverse = ! self.settings.reverse;
			}

			var comparator = lodash.get(activeHeader, 'comparator', null);

			$log.debug('Ordering table', predicate, self.settings.reverse);

			if (self.filteredWines.length){
				self.filteredWines = $filter('orderBy')(self.filteredWines, predicate, self.settings.reverse, comparator);
			}

			self.predicate = predicate;
		}

		function setWines(wines){

			self.wines = wines;

			_setCustomHeaders();

			applyFiltersAndSearches();
		}

		function _setCustomHeaders(){

			WineRepository.getCustomFieldLabels().then(function(labels){

				$log.debug('Custom Labels', labels);

				if (labels.length > 0 && lodash.isArray(labels)){
					$rootScope.$emit('CustomHeadersWereSet');

					lodash.each(labels, function(label){
						appendHeader({
							id: label,
							name: label,
							field: function(record){
								if (lodash.isEmptyOrNull(record.custom) || record.custom.length === 0){
									return null;
								}
								return lodash.get(lodash.findWhere(record.custom, { 'label': label }), 'value', null);
							},
							sort: 'asc'
						});
					});
				}
			}).catch(function(err){
				$log.warn('Custom field design document does not yet exist.');
			});
		}

		function markLoading(){
			$log.debug('Marking Wine Table as loading...');
			self.settings.isLoading = true;
		}

		function doneLoading(){
			$log.debug('Marking Wine Table as done loading...');
			self.settings.isLoading = false;
		}

		function applyFiltersAndSearches(){

			if (! self.wines.length){
				return false;
			}

			return applyActiveFilter(self.wines)
				.then(applySimpleQuery)
				.then(applyAdvancedQuery)
				.then(function(wines){
					$log.debug('Setting filtered wines...');
					self.filteredWines = wines;
					
					orderTable(self.settings.column, true);
				});
		}

		function applyActiveFilter(wines){

			var filteredWines = $filter('filter')(wines, function(wine, index) {
				return wineFilter(wine);
			});

			$log.debug('Applying Active Filter. Wines = ', filteredWines.length);

			return $q.when(filteredWines);
		}

		function applySimpleQuery(wines){

			var query = getQuery();

			if (lodash.isEmptyOrNull(query)){
				$log.debug('No simple query to apply.');
				return $q.when(wines);
			}

			$log.debug('Applying Simple Query', query);

			var filteredWines = wines;

			if (lodash.isNotEmptyOrNull(query)){

				var words = query.split(' ');

				lodash.each(words, function(word) {
					filteredWines = $filter('filter')(wines, word);
				});
			}

			return $q.when(filteredWines);
		}

		function applyAdvancedQuery(wines){

			$log.debug('Applying Advanced Query');

			var filteredWines = wines;

			lodash.forOwn(self.advQuery, function(obj, key){
				var runFilter = false;

				// run it only if value is a string and not empty
				if (lodash.isString(obj.val) && ! isEmptyOrNull(obj.val)){
					runFilter = true;
				}

				// run if obj and has properties that aren't empty (like min or max)
				if (lodash.isObject(obj.val)){
					lodash.forEach(obj.val, function(v, k){
						if (! isEmptyOrNull(v)){
							runFilter = true;
						}
					});
				}

				if (runFilter){
					$log.debug('Running filter... Current:  ', obj.name, obj.val, filteredWines.length);
					filteredWines = obj.cb(filteredWines, obj.val);
					$log.debug('Filter done. Wines = ', filteredWines.length);
				}
			});

			updateAdvQueryCollection();

			return $q.when(filteredWines);
		}

		function getRecordType(wine){
			var recordType = [];

			var qty = lodash.get(wine, 'cellar.qty');

			if (qty > 0){
				recordType.push('Cellar');
			}

			if (lodash.get(wine, 'cellar.history').length && qty === 0){
				recordType.push('Out of Stock');
			}

			if (lodash.get(wine, 'cellar.tasted', false)){
				recordType.push('Tasted Only');
			}

			if (lodash.get(wine, 'cellar.wished', false)){
				recordType.push('Wishlist');
			}

			if (wine.getOnOrderQty() > 0){
				recordType.push('On Order');
			}

			if (lodash.get(wine, 'cellar.starred', false)){
				recordType.push('Favorite');
			}

			recordType = recordType.join(', ');

			// add so we can sort
			wine.recordType = recordType;

			return recordType;
		}

		function getRecordTypeClass(wine){
			var recordType = getRecordType(wine);
			return recordType.indexOf(',') === -1 ? Slug.slugify(recordType) : '';
		}

		function wineFilter(item){
			return $filter('wineFilterFunction')(item, self.settings.selectedFilter);
		}

		function toggleSearch(){
			self.toggleSearch = ! self.toggleSearch;

			return self.toggleSearch;
		}

		function searchIsActive(){
			return self.toggleSearch;
		}

		function resetFilters(){
			self.settings.selectedFilter = null;
		}

		function getWines(){
			return self.wines;
		}

		function currentPage(){
			return self.settings.page;
		}

		function perPage(){
			return self.settings.perPage;
		}

		function getVal(obj, path){
			if (! lodash.isObject(obj)){
				return null;
			}
			if (lodash.isFunction(path)){
				return path(obj);
			}

			return lodash.get(obj, path);
		}

		function getCustomClass(h, obj){

			if (! lodash.isObject(obj)){
				return null;
			}

			var classOrCallback = lodash.get(h, 'ngclass', null);

			if (lodash.isFunction(classOrCallback)){
				return classOrCallback(obj);
			}

			return classOrCallback;
		}

		function resetPagination(){
			self.settings.page = 0;
		}

		function setPerPage(n){
			resetPagination();
			if (n == 'All'){
				self.settings.perPage = undefined;
			} else {
				self.settings.perPage = n;
			}
		}

		function getFilterSummary(){
			return self.settings.selectedFilter.summary;
		}

		function getHeaders(){
			return self.headers;
		}

		function getPredicate(){
			return self.predicate;
		}

		function getOffset(){
			return currentPage() * perPage();
		}

		function getFilters(){
			return self.wineFilters;
		}

		function totalPages(){

			var totalRecords = self.filteredWines.length;

			if (totalRecords === 0){
				return 0;
			}

			if (! angular.isDefined(self.settings.perPage)){
				return 1;
			}

			return Math.ceil(totalRecords / self.settings.perPage);
		}

		function goToPage(page) {
			self.settings.page = page;
		}

		function prevPage(){
			self.settings.page = self.settings.page - 1;
		}

		function nextPage(){
			self.settings.page = self.settings.page + 1;
		}

		function setFilter(filter){
			resetPagination();
			self.settings.selectedFilter = filter;
			applyFiltersAndSearches();
		}

		function setFilterBySlug(slug){
		    setFilter(_.find(self.wineFilters, {slug: slug}));
        }

		function getSelectedFilter(){
			return self.settings.selectedFilter;
		}

		function filteredTotal(){
			return self.filteredWines.length;
		}

		function setFilteredWines(wines){
			self.isFiltered = true;
			self.filteredWines = wines;
			return wines;
		}

		function setQuery(query){
			self.settings.query = query;
			applyFiltersAndSearches();
		}

		function getQuery(){
			return self.settings.query;
		}

		function sortReverse(){
			return self.settings.reverse;
		}

		function addWine(wine){
			var hasWine = lodash.findWhere(self.wines, { '_id': wine._id });

			if (! hasWine){
				self.wines.push(wine);
			}
		}

		function addWines(wines){
			if (wines.length){
				lodash.each(wines, function(wine){
					addWine(wine);
				});
				return true;
			}

			return false;
		}

		function isDirty(){
			return self.isDirty;
		}

		function markDirty(){
			self.isDirty = true;
		}

		function markClean(){
			self.isDirty = false;
		}

		function sortHeader(header){
			self.activeHeader = header;
			self.activeHeader.sort = self.activeHeader.sort === 'asc' ? 'desc' : 'asc';
		}

		function setActiveHeader(index, header){
			self.activeHeaders[index] = header;

			$rootScope.$emit('UserChangedHeaders');
		}

		function getActiveHeaderName(index){
			return self.activeHeaders[index].name;
		}

		// check for input values
		function isEmptyOrNull(val){
			return ! angular.isDefined(val) || val === '' || lodash.isNull(val);
		}

		function getAdvQuery(){
			return self.advQuery;
		}

		function setAdvQuery(query){

			$rootScope.$emit('UserPerformedAdvancedSearch');

			self.advQuery = lodash.merge(self.advQuery, query);

			applyFiltersAndSearches();
		}

		function isAdvSearch(){
			return self.advQueryCollection.length > 0;
		}

		function resetAdvSearch(){

			lodash.forOwn(self.advQuery, function(value, key) {
				if (lodash.isObject(value.val)){
					value.val.min = null;
					value.val.max = null;
				} else {
					value.val = null;
				}
			});

			self.advQueryCollection = [];

			applyFiltersAndSearches();
		}

		function updateAdvQueryCollection(includeAll){

			var collection = lodash.map(lodash.values(self.advQuery), function(n){
				// check for min and max and format accordingly
				if (lodash.isObject(n.val) && (lodash.has(n.val, 'min') || lodash.has(n.val, 'max'))){
					var out = [];

					lodash.forEach(n.val, function(v, k){
						if (v){
							if (lodash.isDate(v)){
								out.push(k + ': ' + $window.moment(v).format('YYYY-MM-DD'));
							} else {
								out.push(k + ': ' + v);
							}
						}
					});

					return {
						name: n.name,
						val: out.join(', ')
					};
				}
				return lodash.pick(n, ['name', 'val']);
			});

			if (! angular.isDefined(includeAll)){
				collection = lodash.reject(collection, {val: null});
				collection = lodash.reject(collection, {val: ''});
			}

			self.advQueryCollection = collection;
		}

		function removeAdvQuery(name){
			return lodash.forOwn(self.advQuery, function(obj, key){
				if (obj.name == name){
					self.advQuery[key].val = null;
					applyFiltersAndSearches();
					return true;
				}
			});
		}

		function setActiveHeadersByIds(ids){

			$log.debug('Setting active headers by id', ids);

			if (ids.length === 0){
				return false;
			}

			var activeHeaders = [];

			var inactiveHeaders = [];

			var takeFrom = [];

			lodash.forEach(ids, function(id){
				var found = lodash.findWhere(self.headers, {id: id});

				if (found){
					activeHeaders.push(found);
				}
			});

			$log.debug('Setting active headers to', lodash.pluck(activeHeaders, 'name'));

			$log.debug('Num columns = ', self.settings.numColumns);

			if (activeHeaders.length < self.settings.numColumns){
				// We don't have enough headers to fill to the desired column size, add inactive ones

				lodash.forEach(self.headers, function(header){
					if (! lodash.includes(ids, header.id)){
						inactiveHeaders.push(header);
					}
				});

				takeFrom = lodash.union(activeHeaders, inactiveHeaders);

			} else {
				takeFrom = activeHeaders;
			}

			self.activeHeaders = lodash.take(takeFrom, self.settings.numColumns);
		}

		function floatSortCallback(val, zeroToNull){
			var parsedFloat = parseFloat(val);

			if (zeroToNull && parsedFloat === 0){
				return null;
			}

			return ! lodash.isNaN(parsedFloat) ? parsedFloat : null;
		}

		function integerSortCallback(val, zeroToNull){
			var parsedInt = lodash.parseInt(val);

			if (zeroToNull && parsedInt === 0){
				return null;
			}

			return ! lodash.isNaN(parsedInt) ? parsedInt : null;
		}

		function chooseAllFilter(){
			self.setFilter(self.wineFilters[0]);
		}

		function setNumHeaderColumns(numColumns){
			if (lodash.isEmptyOrNull(numColumns)){
				return false;
			}
			self.settings.numColumns = numColumns;

			// take current active header ids and set
			var headerIds = lodash.pluck(self.activeHeaders, 'id');

			setActiveHeadersByIds(headerIds);

			return true;
		}

		function removeById(id){
			if (! id.length){
				return false;
			}

			var f1 = lodash.remove(self.wines, function(w) {
				return lodash.get(w, '_id') === id;
			});

			var f2 = lodash.remove(self.filteredWines, function(w) {
				return lodash.get(w, '_id') === id;
			});

			return f1.length || f2.length;
		}

		function compare(val, min, max){
			if (lodash.isNotEmptyOrNull(min) && lodash.isNotEmptyOrNull(max)){
				return val >= min && val <= max;
			}
			if (lodash.isNotEmptyOrNull(min) && val >= min){ return true; }
			if (lodash.isNotEmptyOrNull(max) && val <= max){ return true; }
			return false;
		}

		function appendHeader(header){
			if (! lodash.findWhere(self.headers, { "id": header.id })){
				self.headers.push(header);
				return true;
			}
			return false;
		}
	}

})();
